import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'

// load dayjs locales
import 'dayjs/locale/fr'

import common from './fr/common.json'

import account from './fr/pages/account.json'
import attendances from './fr/pages/attendances.json'
import briefings from './fr/pages/briefings.json'
import chat from './fr/pages/chat.json'
import clients from './fr/pages/clients.json'
import emc2 from './fr/pages/emc2.json'
import equipments from './fr/pages/equipments.json'
import field from './fr/pages/field.json'
import hr from './fr/pages/hr.json'
import index from './fr/pages/index.json'
import panels from './fr/pages/panels.json'
import pollsters from './fr/pages/pollsters.json'
import programs from './fr/pages/programs.json'
import projects from './fr/pages/projects.json'
import reports from './fr/pages/reports.json'
import resourcesi18N from './fr/pages/resources.json'
import stops from './fr/pages/stops.json'
import tallies from './fr/pages/tallies.json'
import users from './fr/pages/users.json'

import pollsterApp from './fr/pollster-app.json'

export const resources = {
  fr: {
    common,
    pollsterApp,
    pages: {
      account,
      attendances,
      briefings,
      chat,
      clients,
      emc2,
      equipments,
      field,
      hr,
      index,
      panels,
      pollsters,
      programs,
      projects,
      reports,
      stops,
      tallies,
      users,
      resources: resourcesi18N,
    },
  },
}
export const initI18n = () => {
  i18next.use(initReactI18next).init({
    lng: 'fr',
    debug: false,
    returnNull: false,
    resources,
    ns: ['common', 'pollsterApp', 'pages'],
    defaultNS: 'common',
  })

  dayjs.extend(localizedFormat)
  dayjs.locale(i18next.language)
}
